import React, { useState, useEffect, useRef, useMemo } from "react";
import "../../assets/css/payment.scss";
import Title from "./../../components/ReusableComponents/title";
import caret from "../../assets/images/charm_tick.svg";
import invoice from "../../assets/icons/invoice.svg";
import { useSelector, useDispatch } from "react-redux";
import loggedReducer from "../../store/reducers/isLogged";
import useMobile from "../../hooks/useMobile";
import { dollarUS, dollarUSK, formatDate } from "../../utilities/formatters";
import { axiosInstance } from "../../Axios";
import { tokenConfig } from "../../store/reducers/tokenReducer";
import { myStore } from "../..";
import Loader from "../../reusableComponents/Loader";
import { setLoading } from "../../store/reducers/loader";
import dropdownIcon from "../../assets/icons/dropdown.svg";
import { Calendar } from "react-calendar";
import PaginationComponent from "../../utilities/Pagination";
import TickIcon from "../../assets/icons/tick-close.svg";
import crossIcon from "../../assets/icons/circle-close.svg";
import progressIcon from "../../assets/icons/progress-cricle.svg";
import dayjs from "dayjs";
import ReactTable from "../../components/ReactTable/ReactTable";

const StatFormatter = (data) => {
  const Stat = data.toLowerCase();
  const classList =
    Stat === "succeeded"
      ? "StatusPassed"
      : Stat.includes("pending")
      ? "StatusProgress"
      : "StatusFailed";

  return (
    <div className={`Status ${classList}`}>
      {Stat === "succeeded" ? (
        <img src={TickIcon} alt="" className="status-icon" />
      ) : Stat.includes("pending") ? (
        <img src={progressIcon} alt="" className="status-icon" />
      ) : (
        <img src={crossIcon} alt="" className="status-icon" />
      )}
      {data.includes("Pending") ? "Pending" : data}
    </div>
  );
};

const userNameFormatter = (cell) => {
  return (
    <div className="column username" style={{ whiteSpace: "nowrap" }}>
      {cell}
    </div>
  );
};

const PaymentHistory = () => {
  const [DataInfo, setDataInfo] = useState([]);
  const ACCtoken = useSelector((state) => state.ACCtoken);
  const dispatch = useDispatch();
  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(loader);
  const isMobile = useMobile();

  const [search, setSearch] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedPlan, setSelectedPlan] = useState("All");
  const [showChall, setShowChall] = useState(false);
  const [showPlan, setShowPlan] = useState(false);
  const [showCalender, setShowCalender] = useState(false);
  const [List, setList] = useState([]);
  const [ListAll, setListAll] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const challengeValues = {
    "25K Challenge": 25000,
    "50K Challenge": 50000,
    "100K Challenge": 100000,
    "200K Challenge": 200000,
    All: null,
  };

  const [selectedChallenge, setSelectedChallenge] = useState("All");

  const planPopupRef = useRef(null);
  const challengePopupRef = useRef(null);
  const calendarRef = useRef(null);

  useEffect(() => {
    setOpen(loader);
  }, [loader]);

  useEffect(() => {
    fetchPaymentHistory();
  }, [dateRange, selectedPlan, selectedChallenge]);

  const fetchPaymentHistory = () => {
    dispatch(setLoading(true));
    const params = { ordering: "created_at" };

    if (dateRange[0]) {
      params.start_date = dayjs(dateRange[0]).format("YYYY-MM-DD");
    }
    if (dateRange[1]) {
      params.end_date = dayjs(dateRange[1]).format("YYYY-MM-DD");
    }
    if (search) {
      params.search = search;
    }
    if (selectedPlan && selectedPlan !== "All") {
      params.Funding_evaluation = selectedPlan;
    }

    const maxBalance = challengeValues[selectedChallenge];
    if (maxBalance !== null) {
      params.account_balance_max = maxBalance;
      params.account_balance_min = maxBalance;
    }

    axiosInstance
      .get("/v2/transaction/history/", {
        ...tokenConfig(myStore.getState),
        params,
      })
      .then((res) => {
        dispatch(setLoading(false));
        if (res.data === "No Cases found!") {
          alert("No Cases found!");
          return;
        }
        if (res.data === "Please verify the Access Token!") {
          dispatch(loggedReducer());
          return;
        }
        setDataInfo(res.data);
      })
      .catch((error) => {
        dispatch(setLoading(false));
        console.error(error);
      });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        planPopupRef.current &&
        !planPopupRef.current.contains(event.target) &&
        showPlan
      ) {
        setShowPlan(false);
      }
      if (
        challengePopupRef.current &&
        !challengePopupRef.current.contains(event.target) &&
        showChall
      ) {
        setShowChall(false);
      }
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        showCalender
      ) {
        setShowCalender(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPlan, showChall, showCalender]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const ShowCalender = () => {
    setShowCalender(!showCalender);
  };

  const pageCount = Math.ceil(DataInfo.length / pageSize);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const currentData = DataInfo.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const ShowChallenge = () => {
    setShowChall(!showChall);
  };

  const ShowPlan = () => {
    setShowPlan(!showPlan);
  };

  const ChallengePopup = () => {
    const handleChallengeSelect = (challenge) => {
      setSelectedChallenge(challenge);
      setCurrentPage(1);
    };

    const challenges = [
      "All",
      "25K Challenge",
      "50K Challenge",
      "100K Challenge",
      "200K Challenge",
    ];

    return (
      <div className="DropChall" ref={challengePopupRef}>
        {challenges.map((challenge) => (
          <div
            key={challenge}
            className={`DropOpt d-flex justify-content-between ${
              selectedChallenge === challenge ? "selected" : ""
            }`}
            onClick={() => handleChallengeSelect(challenge)}
          >
            <Title four>{challenge}</Title>
            <div className="checkbox">
              {selectedChallenge === challenge && <img src={caret} alt="" />}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
    setCurrentPage(1);
  };

  const PlanPopup = () => {
    const plans = [
      "All",
      "Alpha pro",
      "Free Trial",
      "Alpha Pro Plus",
      "Scaling",
      "Swing",
    ];

    return (
      <div className="DropChall" ref={planPopupRef}>
        {plans.map((plan) => (
          <div
            key={plan}
            className={`DropOpt d-flex justify-content-between ${
              selectedPlan === plan ? "selected" : ""
            }`}
            onClick={() => handlePlanSelect(plan)}
          >
            <Title four>{plan}</Title>
            <div className="checkbox">
              {selectedPlan === plan && <img src={caret} alt="" />}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const [date, setDate] = useState(new Date());
  const handleChangeCalender = (e) => {
    setListAll(false);
    setList(false);
    var doptions = {
      day: "numeric",
      month: "short",
      year: "numeric",
    };
    let var1 = e.target.value.toLocaleDateString("en-GB", doptions);
    setDate(var1);
    alert(var1);
  };

  const handleDateRangeChange = (range) => {
    if (range.length === 2) {
      const [startDate, endDate] = range;
      setDateRange([startDate, endDate]);
      setCurrentPage(1);
    }
  };

  const handleResetCalendar = () => {
    setDateRange([null, null]);
    setShowCalender(false);
  };

  const TableCalender = ({ dateRange }) => {
    return (
      <div className="TableCalenderBox" ref={calendarRef}>
        <Calendar
          selectRange={true}
          onChange={handleDateRangeChange}
          value={dateRange}
        />
        <div className="calendar_btns">
          <button onClick={handleResetCalendar} className="reset-calendar-btn">
            Reset
          </button>
          <button
            onClick={() => setShowCalender(false)}
            className="reset-calendar-btn"
          >
            Close
          </button>
        </div>
      </div>
    );
  };

  // Define columns for ReactTable
  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "expander",
        width: 40,
        Cell: ({ row }) => (
          <span
            {...row.getToggleRowExpandedProps()}
            style={{ cursor: "pointer" }}
          >
            {row.isExpanded ? (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M19 13H5V11H19V13Z" fill="#B0B0B0" />
              </svg>
            ) : (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                  fill="#B0B0B0"
                />
              </svg>
            )}
          </span>
        ),
      },
      {
        Header: "Funding Evaluation",
        accessor: "Funding_evaluation",
        width: 150,
        Cell: ({ row }) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "3px",
            }}
          >
            {userNameFormatter(row.original.Funding_evaluation)}
            {row.original.Account_balance
              ? dollarUSK(Number(row.original.Account_balance))
              : false}
          </div>
        ),
      },
      {
        Header: "Transaction ID",
        accessor: "payment_id",
        width: 250,
        Cell: ({ value }) => <div className="paymentTD">{value}</div>,
      },
      {
        Header: () => (
          <div className="dateCalendarContainer">
            Date
            <span style={{ cursor: "pointer" }} onClick={ShowCalender}>
              <img src={dropdownIcon} alt="" />
            </span>
            <div className="ShowChallengePopup">
              {showCalender && <TableCalender dateRange={dateRange} />}
            </div>
          </div>
        ),
        accessor: "date",
        width: 170,
        Cell: ({ value }) => (value ? formatDate(new Date(value)) : false),
      },
      {
        Header: "Amount",
        accessor: "amount",
        width: 120,
        Cell: ({ value }) => (
          <span>{value ? dollarUS(Number(value) / 100) : false}</span>
        ),
      },
      {
        Header: "Invoice",
        accessor: "invoice",
        width: 100,
        Cell: ({ value }) =>
          value && value !== "N/A" ? (
            <a
              href={value}
              target="_blank"
              rel="noreferrer"
              style={{ color: "#0D56EB" }}
            >
              <img src={invoice} alt="" className="invoice-icon" />
            </a>
          ) : (
            <span className="no-invoice">N/A</span>
          ),
      },
      {
        Header: "Status",
        accessor: "payment_status",
        width: 200,
        Cell: ({ value }) => StatFormatter(value),
      },
    ],
    [showCalender, dateRange]
  );

  return (
    <div
      className="PageContainer LeaderboardPage PaymentHistoryPage payment_history mtt-20"
      style={{ position: "relative" }}
    >
      <Loader open={open} />
      <div className="HistoryDesk">
        <div className="affiliateTableContainer">
          <ReactTable
            columns={columns}
            data={currentData || []}
            manualPagination={true}
            page={currentPage}
            pageSize={pageSize}
            onPageChange={handlePageChange}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            totalCount={DataInfo.length}
            renderRowSubComponent={({ row }) => {
              try {
                const metaData = JSON.parse(row.original?.meta_data || "{}");
                return (
                  <div className="expanded-content" style={{ padding: "20px" }}>
                    {Object.entries(metaData)
                      .filter(
                        ([key]) =>
                          ![
                            "tnc",
                            "profit_split",
                            "payout_type",
                            "user_joined",
                            "host",
                          ].includes(key)
                      )
                      .map(([key, value]) => (
                        <div
                          key={key}
                          className="expanded-detail"
                          style={{ marginBottom: "8px" }}
                        >
                          <strong
                            style={{
                              textTransform: "capitalize",
                              marginRight: "8px",
                            }}
                          >
                            {key.replace(/_/g, " ")}:
                          </strong>
                          <span>
                            {value === true
                              ? "Yes"
                              : value === false
                              ? "No"
                              : value?.toString() || "N/A"}
                          </span>
                        </div>
                      ))}
                  </div>
                );
              } catch (error) {
                return (
                  <div className="expanded-detail" style={{ padding: "20px" }}>
                    <strong>Meta Data:</strong> Invalid JSON format
                  </div>
                );
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentHistory;
